import { combineReducers, configureStore } from '@reduxjs/toolkit';

import * as reducers from './slices/index';
import { api } from './api/baseApi';
import { customViewsReducer } from './slices/customViews';

const rootReducer = combineReducers({
  ...reducers,
  [api.reducerPath]: api.reducer,
  currentView: customViewsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
  devTools: { maxAge: 50, trace: true, traceLimit: 25 },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
